import { EArrowsSize } from '../types';
export var DEFAULT_CONTROLS_OFFSET = 9;
export var DEFAULT_ARROW_ICON_SIZE = 24;
export var DEFAULT_LARGE_ARROW_ICON_SIZE = 40;
export var RESIZE_TROTTLING_DELAY = 400;
export var SCROLL_TROTTLING_DELAY = 300;
export var SCROLL_TRANSITION_DELAY = 150;
export var SCROLL_AREA = 1 / 6;
export var SCROLL_TRANSITION = "transform ease-out ".concat(SCROLL_TRANSITION_DELAY, "ms");
export var DEFAULT_ARROWS_SETTINGS = {
  alwaysVisible: false,
  size: EArrowsSize.NORMAL
};